// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_33v98","col":"index_col_BnNvS","sizer":"index_sizer_4WgVH","thumbnailWrap":"index_thumbnailWrap_qLDr1","thumbnail":"index_thumbnail_3g9Hs"};